import { AxiosError } from "axios";

import {
  BaseDataQuery,
  ExtendedBaseDataResponseBody,
  ShellDataRequestBody,
  ShellDataResponseBody,
  ShellSecondaryDataRequestQuery,
  ShellSecondaryDataResponseBody,
  GroupTraitsRequestQuery,
  GroupTraitsResponseBody,
} from "../types";
import { get, post } from "./http";

export const defaultData: {
  appShellData: ShellDataResponseBody;
  appShellSecondaryData: ShellSecondaryDataResponseBody;
  groupTraits: GroupTraitsResponseBody;
} = {
  appShellData: {
    b2BAccessPermissions: {
      hasReviewInsights: false,
      hasInvitations: false,
      hasIntegrations: false,
      hasLabs: false,
      hasManageProfile: false,
      hasProductReviews: false,
      hasAnalytics: false,
    },
    businessAccounts: [],
    publicProfileUrl: "",
    selectedBusinessAccountId: "",
    selectedBusinessAccountBusinessUnits: [],
  },
  appShellSecondaryData: {
    billingInfo: null,
    accountManager: {},
    complianceNotifications: [],
    notifications: [],
    unpaidInvoiceInfo: {},
    userPreferences: [],
    reviewCountAwaitingReply: {
      serviceReviewCount: null,
      productReviewCount: null,
      total: null,
    },
  },
  groupTraits: {
    categories: [],
    primaryCategory: "",
    accountId: "",
    accountName: "",
    numberOfUsers: 0,
  },
};

// TODO: isSsoSamlAuthenticated will be part of ShellDataRequestBody schema once API model is published
// see: https://github.com/trustpilot/businessapp-shellapi/pull/109
export const getBaseData = async (
  props: BaseDataQuery & { isSsoSamlAuthenticated: boolean },
): Promise<ExtendedBaseDataResponseBody> => {
  try {
    const { locale = "", businessUnitId = "", isSsoSamlAuthenticated = false } = props;
    const { data }: { data: ExtendedBaseDataResponseBody } = await get(
      `/v1/private/business-users/businessapp-shell/base-data?locale=${locale}&businessUnitId=${businessUnitId}&isSsoSamlAuthenticated=${isSsoSamlAuthenticated}`,
    );
    return data;
  } catch (error) {
    const err = error as AxiosError<{ message: string }>;
    throw err.response?.data?.message || "Error fetching base data";
  }
};

// TODO: isSsoSamlAuthenticated will be part of ShellDataRequestBody schema once API model is published
// see: https://github.com/trustpilot/businessapp-shellapi/pull/108
export const getShellData = async (
  props: ShellDataRequestBody & { isSsoSamlAuthenticated: boolean },
): Promise<ShellDataResponseBody> => {
  try {
    const { data }: { data: ShellDataResponseBody } = await post(
      "/v1/private/business-users/businessapp-shell/shell-data",
      {
        data: { ...props },
      },
    );

    return data;
  } catch (error) {
    return defaultData.appShellData;
  }
};

export const getShellSecondaryData = async (
  props: ShellSecondaryDataRequestQuery,
): Promise<ShellSecondaryDataResponseBody> => {
  try {
    const { businessUnitId, locale } = props;
    const { data }: { data: ShellSecondaryDataResponseBody } = await get(
      `/v1/private/business-users/businessapp-shell/shell-secondary-data?businessUnitId=${businessUnitId}&locale=${locale}`,
    );
    return data;
  } catch (e) {
    return defaultData.appShellSecondaryData;
  }
};

export const getGroupTraits = async (props: GroupTraitsRequestQuery): Promise<GroupTraitsResponseBody> => {
  try {
    const { businessUnitId } = props;
    const { data }: { data: GroupTraitsResponseBody } = await get(
      `/v1/private/business-users/businessapp-shell/group-traits?businessUnitId=${businessUnitId}`,
    );

    return data;
  } catch (error) {
    return defaultData.groupTraits;
  }
};
